import { render, staticRenderFns } from "./AgentBalance.vue?vue&type=template&id=4161130e&"
import script from "./AgentBalance.vue?vue&type=script&lang=js&"
export * from "./AgentBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports